import type { Table } from "@tanstack/react-table";
import type { IMaterial } from "../../../modelos/Materiales/entidades/IMaterial";
import type { ITipoMaterial } from "../../../modelos/Materiales/entidades/ITipoMaterial";
import type { IFiltroPaginador } from "../../../globales/interfaces";

export interface ITablaMaterialesVistaProps extends IFiltroMaterialesVistaProps {
    tabla: Table<IMaterial>;
    abrirModalMaterial: (estadoModal: boolean, material: IMaterial) => void;
    habilitarFiltros: boolean;
    manejarHabilitarFiltros: (habilitar: boolean) => void;
    limpiarFiltros: () => void;
}

export interface IModalMaterialCVProps {
    consultarMateriales: (filtros: IMaterial, filtroPaginador: IFiltroPaginador) => Promise<void>
    abrirModalMaterial: (estadoModal: boolean, material: IMaterial | null) => void;
    estadoModal: boolean;
}

export interface IMaterialesCVProps {
    nombreTabla: string;
}

export interface IModalMaterialVistaProps {
    abrir: boolean;
    abrirModalMaterial: (estadoModal: boolean, material: IMaterial) => void;
    guardarEditarMaterial: () => void;
    manejarCambioValorMaterial: (campo: keyof IMaterial, valor: IMaterial[keyof IMaterial]) => void;
    agregarError: (campo: keyof IMaterial, error: string) => Promise<void>,
    errores: Partial<Record<keyof IMaterial, string | null>>;
}

export const estadoInicialMaterial: IMaterial = {
    Id: 0,
    Nombre: "",
    TipoMaterialId: 0,
    Moneda:'',
    PrecioLista: 0,
    Sku: '',
    Unidad: '',
    Activo: true,
    Eliminado: false,
};

export interface IFiltroMaterialesVistaProps {
    filtro: IMaterial;
    consultarMateriales: (filtros: IMaterial, filtroPaginador: IFiltroPaginador) => Promise<void>
    tiposMateriales: ITipoMaterial[];
    manejarCambioFiltroMaterial: (campo: keyof IMaterial, valor: IMaterial[keyof IMaterial]) => void;
    limpiarFiltros: () => void;
}
